import React from 'react';
import {
  Bar, BarChart, Cell, ReferenceLine, ResponsiveContainer, XAxis,
} from 'recharts';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { FACET_COLORS, PALETTE } from 'Theme';
import PropTypes from 'prop-types';
import CollapsibleDisclaimer from 'Components/ComponentLibrary/Components/Uncategorized/CollapsibleDisclaimer';
import { FDStack } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

export const MaxLossesAndReturnsSectionForScenarioSelectionModelUpdate = ({
  oneYearMaxLoss,
  threeYearMaxAnnualizedLosses,
  averageAnnualReturn,
  threeYearMaxAnnualizedReturn,
  oneYearMaxReturn,
  disclaimer,
  disclaimerReadMore,
}) => {
  const isMobile = useMobileLayout();
  const data = [
    {
      name: oneYearMaxLoss,
      uv: parseFloat(oneYearMaxLoss),
    },
    {
      name: threeYearMaxAnnualizedLosses,
      uv: parseFloat(threeYearMaxAnnualizedLosses),
    },
    {
      name: averageAnnualReturn,
      uv: parseFloat(averageAnnualReturn),
    },
    {
      name: threeYearMaxAnnualizedReturn,
      uv: parseFloat(threeYearMaxAnnualizedReturn),
    },
    {
      name: oneYearMaxReturn,
      uv: parseFloat(oneYearMaxReturn),
    },
  ];

  const colors = [FACET_COLORS.red.color, FACET_COLORS.orange.color, PALETTE.success.main, FACET_COLORS.accentBlue.color];

  return (
    <FDStack direction={'column'} spacing={3}>
      <FDStack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 2 : 6}>
        <ResponsiveContainer height={181} width={isMobile ? '100%' : '50%'}>
          <BarChart
            data={data}
            height={200}
            margin={{
              top: 0, right: 0, bottom: 0, left: 0,
            }}
          >
            <ReferenceLine strokeDasharray={'2 2'} y={0} stroke={FACET_COLORS.primaryGray.color} />
            <Bar dataKey={'uv'} fill={'#000'}>
              {data.map((entry, index) => (
                <Cell key={`cell-${entry.name}`} fill={colors[index] || FACET_COLORS.primaryBlue.color} />
              ))}
            </Bar>
            <XAxis dataKey={'name'} tickSize={0} axisLine={false} />
          </BarChart>
        </ResponsiveContainer>
        <FDStack direction={'column'} spacing={2} width={isMobile ? '100%' : '50%'}>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <Text variant={'h5'} weight={'medium'} color={'error'} align={'start'} text={'1 Year Maximum Loss'} />
            <Text variant={'h5'} weight={'medium'} color={'error'} align={'start'} text={oneYearMaxLoss} />
          </FDStack>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <Text variant={'h5'} weight={'medium'} color={'warning'} align={'start'} text={'3 Year Maximum Annualized Loss'} />
            <Text variant={'h5'} weight={'medium'} color={'warning'} align={'start'} text={threeYearMaxAnnualizedLosses} />
          </FDStack>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <Text variant={'h5'} weight={'medium'} color={'success'} align={'start'} text={'Average Annual Return'} />
            <Text variant={'h5'} weight={'medium'} color={'success'} align={'start'} text={averageAnnualReturn} />
          </FDStack>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <Text variant={'h5'} weight={'medium'} color={'accentBlue'} align={'start'} text={'3 Year Maximum Annualized Return'} />
            <Text variant={'h5'} weight={'medium'} color={'accentBlue'} align={'start'} text={threeYearMaxAnnualizedReturn} />
          </FDStack>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <Text variant={'h5'} weight={'medium'} align={'start'} text={'1 Year Maximum Return'} />
            <Text variant={'h5'} weight={'medium'} align={'start'} text={oneYearMaxReturn} />
          </FDStack>
        </FDStack>
      </FDStack>
      <CollapsibleDisclaimer
        disclaimerTitle={'Hypothetical Investment Disclaimer'}
        disclaimerText={disclaimer}
        disclaimerReadMore={disclaimerReadMore}
      />
    </FDStack>
  );
};

MaxLossesAndReturnsSectionForScenarioSelectionModelUpdate.propTypes = {
  oneYearMaxLoss: PropTypes.string.isRequired,
  threeYearMaxAnnualizedLosses: PropTypes.string.isRequired,
  averageAnnualReturn: PropTypes.string.isRequired,
  threeYearMaxAnnualizedReturn: PropTypes.string.isRequired,
  oneYearMaxReturn: PropTypes.string.isRequired,
  disclaimer: PropTypes.string.isRequired,
  disclaimerReadMore: PropTypes.string,
};
